import React, { act, useEffect, useState } from "react";
import Header from "./Header";
import { useParams, useNavigate, Link, data } from "react-router-dom";
import apiService from "../Services/apiService";
import fileSample from '../Asset/Samples/Create Responders.xlsx';
import * as XLSX from "xlsx";
import '../../node_modules/react-quill/dist/quill.snow.css';
import ReactQuill from 'react-quill';
import { Modal, Box, Typography, TextField, MenuItem, Select, InputLabel, FormControl, Checkbox, FormControlLabel } from '@mui/material';
import { DatePicker, TimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const ManageReminder = () => {
    const token = localStorage.getItem("JWTToken");
    const [loading, setLoading] = useState(true);
    const { uniqueKey } = useParams();
    const navigate = useNavigate();
    const [respondersCount, setrespondersCount] = useState(0);
    const [DeliveredCount, setDeliveredCount] = useState(0);
    const [StartedCount, setStartedCount] = useState(0);
    const [CapturedCount, setCapturedCount] = useState(0);
    const [CompletedCount, setCompletedCount] = useState(0);
    const [AverageTime, setAverageTime] = useState("0");
    const [SurveyStatus, setSurveyStatus] = useState("");
    const [SurveyName, SetSurveyName] = useState("");
    const [SurveyID, SetSurveyID] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isReminderModalOpen, setIsReminderModalOpen] = useState(false);
    const [excelData, setExcelData] = useState([]);
    const [error, seterror] = useState("");
    const [emailSubject, setEmailSubject] = useState('');
    const [emailBody, setEmailBody] = useState('');
    const [selectedParameter, setSelectedParameter] = useState('');
    const [date, setDate] = useState(null);
    const [time, setTime] = useState(null);
    const [onlyRemindIncomplete, setOnlyRemindIncomplete] = useState(0);
    const [Success, setSuccess] = useState(0);
    const [reminderData, setreminderData] = useState([]);
    const [ResponderData, setResponderData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [activeTab, setActiveTab] = useState("Reminders");

    useEffect(() => {
        if (token && uniqueKey) {
            const GetAuthorization = async () => {
                const response = await apiService.GetAccess(token, uniqueKey);
                if (response) {
                    const surveyDetails = response.SURVEY_DETAILS;
                    const SuveryInsights = response.SURVEY_INSIGHTS
                    var SurveyName = surveyDetails[0].SurveyName;
                    var CanEdit = surveyDetails[0].CanEdit;
                    var CanView = surveyDetails[0].CanView;
                    var CanEnd = surveyDetails[0].CanEnd;
                    var SurveyDecription = surveyDetails[0].SurveyDescription;
                    var SurveyStatus = surveyDetails[0].SurveyStatus;
                    var ImgURL = surveyDetails[0].ThumbnailImageURL;
                    SetSurveyID(surveyDetails[0].SurveyID)
                    setSurveyStatus(SurveyStatus);
                    SetSurveyName(SurveyName);
                    setrespondersCount(SuveryInsights[0].RespondersCount);
                    setDeliveredCount(SuveryInsights[0].DeliveredCount);
                    setStartedCount(SuveryInsights[0].StartedCount);
                    setCapturedCount(SuveryInsights[0].CapturedCount);
                    setCompletedCount(SuveryInsights[0].CompletedCount);
                    setAverageTime(SuveryInsights[0].AverageTime);
                }
            }
            const GetReminderData = async () => {
                const response = await apiService.GetSurveyReminders(token, uniqueKey);
                if (response) {
                    console.log(response);
                    setreminderData(response.RESPONSE);
                } else {
                    setLoading(true)
                }
            }
            const GetRespondersData = async () => {
                const response = await apiService.GetSurveyResponders(token, uniqueKey);
                if (response) {
                    console.log(response);
                    setResponderData(response.RESPONSE);
                } else {
                    setLoading(true)
                }
            }
            GetAuthorization();
            GetReminderData();
            GetRespondersData();
        } else {
            navigate("/Login");
        }

    }, [token, uniqueKey, Success]);

    const handleOpen = () => setIsModalOpen(true);
    const handleClose = () => {
        seterror("")
        setIsModalOpen(false);
    }
    const handleReminderOpen = () => setIsReminderModalOpen(true);
    const handleReminderClose = () => {
        seterror("")
        setIsReminderModalOpen(false);
    }
    const handleDownload = () => {
        debugger;
        const link = document.createElement('a');
        link.href = fileSample;
        link.download = 'Create Responders.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleFileUpload = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                const binaryStr = event.target.result;
                const workbook = XLSX.read(binaryStr, { type: "binary" });

                // Assuming data is in the first sheet
                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convert to JSON
                const jsonData = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

                const extractedData = [];
                const invalidRows = []; // To store invalid row numbers
                const emailSet = new Set(); // To track unique emails

                // Email validation regex (basic format check)
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

                jsonData.forEach((row, index) => {
                    const responderEmail = row["Responder e-mail *"];
                    const responderName = row["Responder Name"];
                    const referenceCode = row["Reference Code/ID"];

                    // Check if email is missing, invalid, or duplicate
                    if (!responderEmail || responderEmail.trim() === "" || !emailRegex.test(responderEmail)) {
                        invalidRows.push(index + 2); // Row numbers are 1-based (index + 2)
                    } else if (emailSet.has(responderEmail)) {
                        invalidRows.push(index + 2); // Duplicate email found
                    } else {
                        // If valid and not a duplicate, add to extractedData and mark email as seen
                        emailSet.add(responderEmail);
                        extractedData.push({
                            responderEmail,
                            responderName,
                            referenceCode,
                        });
                    }
                });

                // Set the error message if there are invalid rows
                if (invalidRows.length > 0) {
                    const errorMessage = `Rows ${invalidRows.join(", ")} have an invalid, missing, or duplicate email.`;
                    seterror(errorMessage); // Display the error message
                } else {
                    seterror(""); // Clear any existing errors
                }

                setExcelData(extractedData);
                console.log("Extracted Data:", extractedData);
                console.log("Invalid Rows:", invalidRows);
            };

            reader.readAsBinaryString(file);
        }
    };
    const handleExcelUpload = async () => {
        if (error) {
            return;
        }
        if (excelData.length === 0) {
            alert("please upload a valid file");
            return;
        }
        debugger;
        const payload = {
            token: token,
            SurveyUID: uniqueKey,
            SurveyID: SurveyID,
            Json: excelData  // Assuming `excelData` contains the parsed responders
        };
        const response = await apiService.CreateResponders(payload);
        if (response) {
            alert("data uploaded successfully")
            setIsModalOpen(false);
            setSuccess(1);
        }
    }
    const handleInsertOption = (event) => {
        const value = event.target.value;
        setSelectedParameter(value);

        let textToAdd = '';
        switch (value) {
            case 'ResponderName':
                textToAdd = '##ResponderName## ';
                break;
            case 'SurveyDeadline':
                textToAdd = '##SurveyDeadline## ';
                break;
            case 'SurveyName':
                textToAdd = '##SurveyName## ';
                break;
            case 'SurveyLink':
                textToAdd = '##SurveyLink## ';
                break;
            default:
                textToAdd = '';
        }

        try {
            // Get the Quill editor instance
            const quill = document.querySelector('.ql-editor');

            if (!quill) {
                throw new Error("Quill editor not found.");
            }

            // Get the current Quill instance (in case it is not directly accessible)
            const quillInstance = quill.closest('.ql-container').__quill;

            if (!quillInstance) {
                throw new Error("Quill instance not found.");
            }

            // Get the current cursor position (index)
            const cursorPosition = quillInstance.getSelection()?.index ?? -1;

            if (cursorPosition !== -1) {
                // Insert the text at the current cursor position
                quillInstance.insertText(cursorPosition, textToAdd);
            } else {
                quillInstance.root.innerHTML += textToAdd;
            }

            setEmailBody(quillInstance.root.innerHTML);

        } catch (error) {
            console.error("Error inserting text into Quill:", error);

            const quill = document.querySelector('.ql-editor');
            if (quill) {
                quill.innerHTML += textToAdd;
            }

            setEmailBody(quill ? quill.innerHTML : '');
        }
    };
    const validateForm = () => {
        if (!emailSubject || !selectedParameter || !emailBody || !date || !time) {
            alert("All fields are required.");
            return false;
        }
        return true;
    };
    const mergeDateTime = (date, time) => {
        if (!date || !time) {
            return ''; // If either date or time is not set, return empty string
        }

        // Merge the date and time (create a new dayjs object with date and time)
        const mergedDateTime = date
            .hour(time.hour())    // Set the hour from the time picker
            .minute(time.minute())  // Set the minute from the time picker
            .second(0)             // Optionally set seconds to 0
            .millisecond(0);      // Optionally set milliseconds to 0

        // Return formatted date and time in 'yyyy/mm/dd hh:mm' format
        return mergedDateTime.format('YYYY/MM/DD HH:mm');
    };
    const handleCreateReminder = async () => {
        debugger;
        const isSurveyLinkPresent = emailBody.includes('##SurveyLink##');
        if (isSurveyLinkPresent) {
            if (validateForm()) {
                const reminderData = {
                    emailSubject,
                    emailBody,
                    startDate: mergeDateTime(date, time),
                    onlyRemindIncomplete,
                };
                const response = await apiService.CreateReminder(token, uniqueKey, reminderData.emailSubject, reminderData.emailBody, reminderData.startDate, reminderData.onlyRemindIncomplete);
                if (response) {
                    alert("Reminder Created successfully");
                    setIsReminderModalOpen(false);
                }
            }
        } else {
            alert("please select the surveylink parameter");
        }

    };
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    }
    const handleShare = async (link) => {
        const shareData = {
            title: "Check this out!",
            text: "Here’s something interesting for you:",
            url: link, // Custom link you want to share
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
                console.log("Shared successfully");
            } catch (error) {
                console.error("Error sharing:", error);
            }
        } else {
            navigator.clipboard.writeText(link);
            alert("Link copied to clipboard!");
        }
    };
    const formatDate = (date) => {
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year}  ${hours}:${minutes}:${seconds}`;
    };
    // Survey Card Component
    const ResponderDataCard = ({ Data }) => {
        debugger;
        return (
            <div className="card Box m-2 p-3 shadow-sm" style={{ width: "14rem", height: "14rem" }}>
                <div className="card-body p-0 d-flex flex-column justify-content-between">
                    <h6 className="card-title fs-14 fw-bold">
                        {Data.ResponderName && Data.ResponderName.length > 40
                            ? `${Data.ResponderName.slice(0, 40)}...`
                            : Data.ResponderName || "No Name"}
                    </h6>
                    <div>
                        <p className="card-text mb-2">{Data.ResponderMail || "No Email"} </p>
                        <p className="card-text mb-2">Total Reminder Send :- {Data.TotalReminderSent || "Null"} </p>
                        <p className="card-text mb-2">
                            Last Reminder send Time: {Data.LastReminderTime ? formatDate(Data.LastReminderTime) : "Null"}
                        </p>
                    </div>
                    <div className="text-end">
                        <button
                            className="ActionBtns"
                            onClick={() => handleShare(`${window.location.origin}/liveSurvey/${Data.ResponderUID}`)}
                        >
                            <i className="fa-solid fa-share"></i>
                        </button>

                    </div>
                </div>
            </div>
        );
    };
  
      // Survey Card Component
      const ReminderDataCard = ({ Data }) => {
        const [showModal, setShowModal] = useState(false);
        const [selectedData, setSelectedData] = useState(null);
    
        const handleShow = () => {
            setSelectedData(Data); 
            setShowModal(true);
        };
    
        const handleReminderViewClose = () => {
            setShowModal(false);
            setSelectedData(null);
        };
        return (
            <>
                <div onClick={handleShow} className="cursor">
                    <div className="card Box m-2 p-3 shadow-sm" style={{ width: "14rem", height: "14rem" }}>
                        <div className="card-body p-0 d-flex flex-column justify-content-between">
                            <h6 className="card-title fs-14 fw-bold">
                                Subject :-   {Data.EmailSubject && Data.EmailSubject.length > 40
                                    ? `${Data.EmailSubject.slice(0, 40)}...`
                                    : Data.EmailSubject || "No Name"}
                            </h6>
                            <div>
                                {/* <p className="card-text mb-2">{Data.EmailBody || "No Name"} </p> */}
                                <p className="card-text mb-2"> Total Send Success Mail  :- {Data.SuccessMail || "Null"} </p>
                                <p className="card-text mb-2"> Total Mail Send :- {Data.TotalMail || "0"} </p>
                                <p className="card-text mb-2">
                                    Reminder send Time:- {Data.ScheduledTime ? formatDate(Data.ScheduledTime) : "Null"}
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
                <Modal open={showModal} onClose={handleReminderViewClose} aria-labelledby="modal-title">
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                        width: 600,
                    }}
                >
                    <h4 id="modal-title" className="text-center">Reminder Details</h4>
                        {selectedData && (
                            <Box sx={{ mt: 2 }}>
                               <h6><strong> Subject:</strong> {selectedData.EmailSubject || "No Email"}</h6>
                            <p><strong>Total Send Success Mail:</strong> {selectedData.SuccessMail || "No Name"}</p>
                            <p><strong>Total Mail Send:</strong> {selectedData.TotalMail || "No Name"}</p>
                            <p><strong>Reminder send Time:</strong> {selectedData.ScheduledTime ? formatDate(selectedData.ScheduledTime) : "No Name"}</p>
                                <p>
                                    <strong>Email Body:</strong>
                                </p>
                                <Box
                                    sx={{
                                        mt: 1,
                                        p: 2,
                                        border: '1px solid',
                                        borderColor: 'divider',
                                        borderRadius: 1,
                                        bgcolor: 'background.default',
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: selectedData.EmailBody || "<p>No Content</p>" }} className="EmailBody"/>
                                </Box>
                            </Box> 
                    )}
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'end' }}>
                        <button className="text-dark ActionBtns" onClick={handleReminderViewClose}>Cancel</button>
                    </Box>
                </Box>
            </Modal>
            </>
        );
    };
    const filteredResponders = [...new Map(ResponderData.map((res) => [res.ResponderID, res])).values()].filter(
        (responder) =>
            responder.ResponderName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
            responder.ResponderMail?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Filtering Reminders
    const filteredReminders = [...new Map(reminderData.map((rem) => [rem.ID, rem])).values()].filter(
        (reminder) =>
            reminder.EmailSubject?.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (<>
        <Header />
        <div className="min-hight85vh bg-grey">
            <div className="container py-5">
                <h5>
                    <Link className="text-dark" to={"/SurveyList"}>Dashboard</Link> / <Link className="text-dark" to={`/ManageSurvey/${uniqueKey}`}>Manage Survey</Link> /    {SurveyName.length > 40
                        ? `${SurveyName.slice(0, 40)}...`
                        : SurveyName}</h5>
                {/* <h5 className="my-5">  Responder List  </h5> */}
                <div className="my-5">
                    <div className="flex-column justify-content-evenly align-items-center d-flex">
                        <div className="mt-3 mb-4 w-100 justify-content-around align-self-center d-flex">
                            {/* Delivered */}
                            <div className="text-center">
                                <div className="message-label text-center h4">{DeliveredCount}/{respondersCount}</div>
                                <div className="message-label text-center">Delivered</div>
                            </div>

                            {/* Started */}
                            <div className="text-center">
                                <div className="message-label text-center h4">{StartedCount}/{DeliveredCount}</div>
                                <div className="message-label text-center">Started</div>
                            </div>

                            {/* Completed */}
                            <div className="text-center">
                                <div className="message-label text-center h4">{CompletedCount}/{StartedCount}</div>
                                <div className="message-label text-center">Completed</div>
                            </div>

                            {/* Average Completion Time */}
                            <div className="text-center">
                                <div className="message-label text-center h4">{AverageTime}</div>
                                <div className="message-label text-center">Average Completion Time</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="text-end">
                            <button className="py-1 px-4 border-0 Gold br-5 m-2" onClick={handleOpen}>Add Responders</button>
                            <Modal
                                open={isModalOpen}
                                onClose={handleClose}
                                aria-labelledby="modal-title"
                                aria-describedby="modal-description"
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        bgcolor: 'background.paper',
                                        borderRadius: 2,
                                        boxShadow: 24,
                                        p: 4,
                                        width: 600,
                                    }}
                                >
                                    <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                        Create Responsers
                                    </h4>
                                    <Typography id="modal-description" sx={{ mt: 2 }}>
                                        <div>
                                            <div className="mb-3 p-4">
                                                <label htmlFor="">Upload Excel :</label>
                                                <input type="File" className="Sanket-Control" accept=".xls, .xlsx" onChange={handleFileUpload} />
                                                <span className="text-danger">{error}</span>
                                            </div>
                                        </div>
                                    </Typography>
                                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        <button className="text-dark ActionBtns" onClick={handleClose}>
                                            Close
                                        </button>
                                        <button
                                            href="../Asset/Samples/Create Responders.xlsx"
                                            className={`py-1 px-4 border-0 btn-custom br-5 mx-2`}
                                            onClick={handleDownload}> Download Sample</button>
                                        <button
                                            className={`py-1 px-4 border-0 Gold br-5`}
                                            onClick={handleExcelUpload}
                                        > Upload</button>
                                    </Box>
                                </Box>
                            </Modal>
                            <button className="py-1 px-4 border-0 Gold br-5 m-2" onClick={handleReminderOpen}>Add Reminder</button>
                            <Modal
                                open={isReminderModalOpen}
                                onClose={handleReminderClose}
                                aria-labelledby="modal-title"
                                aria-describedby="modal-description"
                            >
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        bgcolor: 'background.paper',
                                        borderRadius: 2,
                                        boxShadow: 24,
                                        p: 4,
                                        width: 600,
                                    }}
                                >
                                    <h4 id="modal-title" className="text-center" sx={{ mt: 2 }}>
                                        Create Reminder
                                    </h4>
                                    <Typography id="modal-description" sx={{ mt: 2 }}>
                                        <div>
                                            <TextField
                                                label="Email Subject"
                                                variant="outlined"
                                                fullWidth
                                                value={emailSubject}
                                                onChange={(e) => setEmailSubject(e.target.value)}
                                                margin="normal"
                                            />

                                            <FormControl fullWidth>
                                                <InputLabel>Parameter</InputLabel>
                                                <Select
                                                    value={selectedParameter}
                                                    onChange={handleInsertOption}
                                                    label="Parameter"
                                                >
                                                    <MenuItem value="">Select Parameter</MenuItem>
                                                    <MenuItem value="ResponderName">Responder Name</MenuItem>
                                                    <MenuItem value="SurveyDeadline">Survey Deadline</MenuItem>
                                                    <MenuItem value="SurveyName">Survey Name</MenuItem>
                                                    <MenuItem value="SurveyLink">Survey Link</MenuItem>
                                                </Select>
                                            </FormControl>

                                            <div style={{ margin: '13px 0px', maxHeight: '200px', overflow: "auto" }}>
                                                <ReactQuill
                                                    value={emailBody}
                                                    onChange={setEmailBody}
                                                    theme="snow"
                                                    placeholder="Enter your email body here..."
                                                />
                                            </div>

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 2 }}>
                                                    <DatePicker
                                                        label="Date"
                                                        value={date}
                                                        onChange={setDate}
                                                        renderInput={(props) => <TextField {...props} fullWidth />}
                                                    />
                                                    <TimePicker
                                                        label="Time"
                                                        value={time}
                                                        onChange={setTime}
                                                        renderInput={(props) => <TextField {...props} fullWidth />}
                                                    />
                                                </Box>
                                            </LocalizationProvider>

                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={onlyRemindIncomplete}
                                                        onChange={() => setOnlyRemindIncomplete(!0)}
                                                    />
                                                }
                                                label="Only remind people who haven’t finished the survey"
                                            />
                                        </div>
                                    </Typography>
                                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                                        <button className="text-dark ActionBtns" onClick={handleReminderClose}>
                                            Cancel
                                        </button>
                                        <button
                                            className={`py-1 px-4 border-0 Gold br-5`}
                                            onClick={handleCreateReminder}
                                        > Create Reminder</button>
                                    </Box>
                                </Box>
                            </Modal>
                        </div>
                        <div>
                            {
                                loading ? (<>
                                    {/* <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div> */}
                                    {/* <p className="my-3 text-center">
                                    No reminder found.
                                    </p> */}
                                </>) : (<>


                                </>)
                            }
                        </div>
                    </div>
                </div>
                <div className="container py-4 min-hight400px">
                    {/* Tabs for switching between survey categories */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="nav nav-tabs">
                            <button
                                className={`nav-link ${activeTab === "Reminders" ? "active" : ""}`}
                                onClick={() => handleTabChange("Reminders")}
                            >
                                Reminders
                            </button>
                            <button
                                className={`nav-link ${activeTab === "Responders" ? "active" : ""}`}
                                onClick={() => handleTabChange("Responders")}
                            >
                                Responders
                            </button>
                        </div>
                        <div>
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="form-control mb-3"
                            />
                        </div>
                    </div>
                    <div className="d-flex flex-wrap align-items-center">
                    {activeTab === "Responders" ? (
                filteredResponders.length > 0 ? (
                    filteredResponders.map((Responder) => (
                        <ResponderDataCard key={Responder.ResponderID} Data={Responder} />
                    ))
                ) : (
                    <p>No Responders found</p>
                )
            ) : activeTab === "Reminders" ? (
                filteredReminders.length > 0 ? (
                    filteredReminders.map((reminder) => (
                        <ReminderDataCard key={reminder.ID} Data={reminder} />
                    ))
                ) : (
                    <p>No Reminders found</p>
                )
            ) : (
                <p>No Data available</p>
            )}

                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default ManageReminder;